(() => {
  function init(root) {
    if (root.dataset.mrfReady === 'true') return;
    root.dataset.mrfReady = 'true';
    const messages = JSON.parse(root.querySelector('[data-mrf-messages]').textContent);
    const variantMaps = new WeakMap();
    let toastTimeout;
    const toast = (text) => {
      const node = root.querySelector('[data-mrf-global-feedback]');
      if (!node) return;
      clearTimeout(toastTimeout);
      node.textContent = text;
      node.classList.add('is-visible');
      toastTimeout = setTimeout(() => node.classList.remove('is-visible'), 4500);
    };
    const updateCard = (card) => {
      const form = card.querySelector('[data-mrf-form]');
      const option = form.querySelector('[data-mrf-variant]:checked');
      if (!option) return null;
      const effective = form.querySelector('[data-mrf-effective-variant]');
      const complete = updateConfiguration(form);
      let variant;
      if (effective) {
        const variants = variantMaps.get(form) || [];
        const sizeVariants = variants.filter((entry) => entry.size === option.dataset.size);
        const findVariant = (cylinder, barrel) => sizeVariants.find((entry) => entry.cylinder === cylinder && entry.barrel === barrel);
        const base = findVariant(false, false);
        const cylinderVariant = findVariant(true, false);
        const barrelVariant = findVariant(false, true);
        const pricedCylinder = base && cylinderVariant && cylinderVariant.price > base.price && cylinderVariant.surcharge ? cylinderVariant : null;
        const pricedBarrel = base && barrelVariant && barrelVariant.price > base.price && barrelVariant.surcharge ? barrelVariant : null;
        const cylinderSelected = Boolean(form.querySelector('[data-mrf-tool-choice][data-tool-id="cylinder"]')?.checked);
        const barrelSelected = Boolean(form.querySelector('[data-mrf-tool-choice][data-tool-id="new_tonneau"]')?.checked);
        const hasSurcharge = cylinderSelected || barrelSelected;
        const candidate = findVariant(cylinderSelected, barrelSelected);
        // The selected Shopify variant is the price authority. Never fall back to
        // a cheaper variant if either premium or their combined variant is missing.
        const expectedPrice = base && base.price + (cylinderSelected && pricedCylinder ? pricedCylinder.price - base.price : 0) + (barrelSelected && pricedBarrel ? pricedBarrel.price - base.price : 0);
        const pricingValid = Boolean(base && candidate && (!cylinderSelected || pricedCylinder) && (!barrelSelected || pricedBarrel) && candidate.price === expectedPrice && (!hasSurcharge || candidate.surcharge));
        variant = pricingValid ? candidate : null;
        effective.value = variant ? String(variant.id) : '';
        effective.disabled = !variant || !variant.available || !complete;
        const cylinderBadge = form.querySelector('[data-mrf-cylinder-price]');
        const barrelBadge = form.querySelector('[data-mrf-barrel-price]');
        if (cylinderBadge) cylinderBadge.textContent = pricedCylinder ? '+' + pricedCylinder.surcharge : messages.unavailable;
        if (barrelBadge) barrelBadge.textContent = pricedBarrel ? '+' + pricedBarrel.surcharge : messages.unavailable;
        const details = [];
        if (cylinderSelected && pricedCylinder) details.push(messages.cylinderName + ' : +' + pricedCylinder.surcharge);
        if (barrelSelected && pricedBarrel) details.push(messages.barrelName + ' : +' + pricedBarrel.surcharge);
        const note = form.querySelector('[data-mrf-surcharge-note]');
        const noteText = hasSurcharge ? (variant && variant.available ? messages.supplementsSelected.replace('{{ details }}', details.join(' · ')).replace('{{ price }}', variant.surcharge) : messages.supplementsUnavailable) : '';
        if (note) {
          if (note.textContent !== noteText) note.textContent = noteText;
          note.hidden = !hasSurcharge;
          note.dataset.error = String(hasSurcharge && (!variant || !variant.available));
        }
        const cylinderProperty = form.querySelector('[data-mrf-surcharge-value]');
        const barrelProperty = form.querySelector('[data-mrf-barrel-surcharge-value]');
        if (cylinderProperty) {
          cylinderProperty.value = cylinderSelected && pricedCylinder ? '+' + pricedCylinder.surcharge : '';
          cylinderProperty.disabled = !cylinderProperty.value;
        }
        if (barrelProperty) {
          barrelProperty.value = barrelSelected && pricedBarrel ? '+' + pricedBarrel.surcharge : '';
          barrelProperty.disabled = !barrelProperty.value;
        }
      } else {
        variant = { id: option.value, money: option.dataset.price, size: option.dataset.size, available: option.dataset.available === 'true', min: option.dataset.min, increment: option.dataset.increment, max: option.dataset.max };
      }
      card.querySelector('[data-mrf-price]').textContent = variant ? variant.money : messages.unavailable;
      card.querySelector('[data-mrf-size-label]').textContent = option.dataset.size;
      card.querySelectorAll('a[href*="/products/"]').forEach((link) => {
        const url = new URL(link.href, window.location.href);
        if (variant) url.searchParams.set('variant', String(variant.id));
        else url.searchParams.delete('variant');
        link.href = url.pathname + url.search + url.hash;
      });
      const quantity = form.elements.quantity;
      const min = Number(variant?.min) || 1;
      const increment = Number(variant?.increment) || 1;
      quantity.min = String(min);
      quantity.step = String(increment);
      if (variant?.max) quantity.max = String(variant.max);
      else quantity.removeAttribute('max');
      const current = Number(quantity.value);
      if (!Number.isInteger(current) || current < min || (current - min) % increment !== 0 || (quantity.max && current > Number(quantity.max))) quantity.value = String(min);
      const add = form.querySelector('[data-mrf-add]');
      add.disabled = !variant?.available || !complete || form.dataset.busy === 'true' || form.dataset.uncertain === 'true';
      add.textContent = form.dataset.busy === 'true' ? messages.adding : variant?.available ? messages.add : messages.unavailable;
      return variant;
    };
    const getProperties = (form) => {
      const properties = {};
      form.querySelectorAll('[name^="properties["]').forEach((field) => {
        if (!field.name || field.disabled || (field.type === 'radio' && !field.checked) || (field.type === 'checkbox' && !field.checked)) return;
        const match = field.name.match(/^properties\[(.+)\]$/);
        if (match && field.value) properties[match[1]] = field.value;
      });
      return properties;
    };
    const updateConfiguration = (form) => {
      const config = form.querySelector('[data-mrf-config]');
      if (!config) return true;
      const limit = Number(config.dataset.toolLimit);
      const choices = Array.from(config.querySelectorAll('[data-mrf-tool-choice]'));
      const selected = choices.filter((choice) => choice.checked);
      const count = config.querySelector('[data-mrf-tool-count]');
      const hidden = config.querySelector('[data-mrf-tool-value]');
      const ids = config.querySelector('[data-mrf-tool-ids]');
      const feedback = config.querySelector('[data-mrf-config-feedback]');
      if (count) count.textContent = messages.toolCount.replace('{{ count }}', String(selected.length)).replace('{{ limit }}', String(limit));
      if (hidden) hidden.value = selected.map((choice) => choice.value).join(', ');
      if (ids) ids.value = selected.map((choice) => choice.dataset.toolId).join(',');
      choices.forEach((choice) => { choice.disabled = !choice.checked && selected.length >= limit; });
      const nails = Array.from(config.querySelectorAll('[data-mrf-nail-select]'));
      const nailValues = nails.map((select) => select.value).filter(Boolean);
      const nailsValid = nails.length === 0 || (nailValues.length === nails.length && new Set(nailValues).size === nails.length);
      const toolsValid = selected.length === limit;
      const fileChoices = Array.from(config.querySelectorAll('input[name="properties[Lime incluse]"]'));
      const fileValid = fileChoices.length === 0 || fileChoices.some((choice) => choice.checked);
      if (feedback && nailsValid && toolsValid && fileValid) feedback.textContent = '';
      return nailsValid && toolsValid && fileValid;
    };
    root.querySelectorAll('[data-mrf-card]').forEach((card) => {
      const form = card.querySelector('[data-mrf-form]');
      const map = form.querySelector('[data-mrf-variant-map]');
      if (map) {
        try { variantMaps.set(form, JSON.parse(map.textContent)); }
        catch (_) { variantMaps.set(form, []); }
      }
      updateCard(card);
      form.addEventListener('change', (event) => {
        if (event.target.matches('[data-mrf-variant], [data-mrf-tool-choice], [data-mrf-nail-select], input[name^="properties["]')) updateCard(card);
      });
      form.addEventListener('mrf:composition-confirmed', () => updateCard(card));
      form.addEventListener('mrf:composition-invalidated', () => updateCard(card));
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (form.dataset.busy === 'true' || form.dataset.uncertain === 'true') return;
        const variant = updateCard(card);
        if (!variant || !variant.available) return;
        const quantity = Number(form.elements.quantity.value);
        const min = Number(variant.min) || 1;
        const step = Number(variant.increment) || 1;
        const max = variant.max ? Number(variant.max) : Infinity;
        const feedback = form.querySelector('[data-mrf-feedback]');
        const cartLink = form.querySelector('[data-mrf-cart-link]');
        const config = form.querySelector('[data-mrf-config]');
        if (!updateConfiguration(form)) {
          const configFeedback = config && config.querySelector('[data-mrf-config-feedback]');
          if (configFeedback) configFeedback.textContent = messages.configuration;
          const nailSelects = config ? Array.from(config.querySelectorAll('[data-mrf-nail-select]')) : [];
          const nailsMissing = nailSelects.some(select => !select.value) || (nailSelects.length > 0 && new Set(nailSelects.map(select => select.value)).size < nailSelects.length);
          const group = config && config.querySelector(nailsMissing ? '[data-mrf-nail-enhancement]:not([hidden]), [data-mrf-nails]:not([hidden])' : '[data-mrf-tool-group]');
          if (group) group.scrollIntoView({ behavior: 'smooth', block: 'center' });
          group?.querySelector('input:not(:disabled), select:not(:disabled)')?.focus({ preventScroll: true });
          return;
        }
        if (!Number.isInteger(quantity) || quantity < min || quantity > max || (quantity - min) % step !== 0) {
          feedback.textContent = messages.quantity;
          feedback.dataset.error = 'true';
          form.elements.quantity.focus();
          return;
        }
        let composition = null;
        try {
          const cached = config ? window.YvarMrfComposition?.confirmed(form) : null;
          if (cached && String(cached.variantId) === String(variant.id)) composition = cached;
        } catch (_) {}
        const properties = getProperties(form);
        delete properties._mrf_composition;
        if (composition) properties._mrf_composition = composition.signature;
        let requestBody = JSON.stringify({ items: [{ id: Number(variant.id), quantity, properties }] });
        let requestHeaders = { 'Content-Type': 'application/json', Accept: 'application/json' };
        if (composition) {
          try {
            const match = composition.pngDataURL.match(/^data:image\/png;base64,([A-Za-z0-9+/=]+)$/);
            if (!match || match[1].length > 8 * 1024 * 1024) throw new Error('Invalid preview');
            const binary = atob(match[1]);
            const bytes = Uint8Array.from(binary, character => character.charCodeAt(0));
            const data = new FormData();
            data.set('id', String(variant.id)); data.set('quantity', String(quantity));
            properties._mrf_composition = composition.signature;
            Object.entries(properties).forEach(([key, value]) => data.set('properties[' + key + ']', value));
            data.set('properties[' + messages.compositionPreviewLabel + ']', new File([bytes], 'MR-FINGER-' + composition.state.kit + '-' + composition.state.size + '.png', { type: 'image/png' }));
            requestBody = data; requestHeaders = { Accept: 'application/json' };
          } catch (_) {
            delete properties._mrf_composition;
            requestBody = JSON.stringify({ items: [{ id: Number(variant.id), quantity, properties }] });
            requestHeaders = { 'Content-Type': 'application/json', Accept: 'application/json' };
          }
        }
        form.dataset.busy = 'true';
        const lockedControls = Array.from(form.querySelectorAll('input, select, button')).map(node => [node, node.disabled]);
        lockedControls.forEach(([node]) => { node.disabled = true; });
        const add = form.querySelector('[data-mrf-add]');
        add.disabled = true;
        add.textContent = messages.adding;
        feedback.textContent = '';
        feedback.dataset.error = 'false';
        cartLink.hidden = true;
        form.setAttribute('aria-busy', 'true');
        const controller = new AbortController();
        const deadline = setTimeout(() => controller.abort(), 30000);
        let confirmed = false;
        let rejected = false;
        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST',
            signal: controller.signal,
            credentials: 'same-origin',
            headers: requestHeaders,
            body: requestBody
          });
          const result = await response.json();
          if (!response.ok) {
            rejected = true;
            throw new Error(typeof result.description === 'string' ? result.description : messages.error);
          }
          confirmed = true;
          feedback.textContent = messages.added;
          cartLink.hidden = false;
          toast(messages.added);
          try {
            const cartResponse = await fetch(root.dataset.cartJsonUrl, { credentials: 'same-origin', signal: controller.signal, headers: { Accept: 'application/json' } });
            if (cartResponse.ok) {
              const cart = await cartResponse.json();
              root.querySelectorAll('[data-mrf-cart-count]').forEach((node) => { node.textContent = String(cart.item_count); });
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart, source: 'mr-finger' } }));
              try {
                const { CartLinesUpdateEvent } = await import('@shopify/events');
                root.dispatchEvent(new CartLinesUpdateEvent({
                  action: 'add', context: 'product',
                  lines: [{ merchandiseId: String(variant.id), quantity }],
                  promise: Promise.resolve({
                    cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
                    detail: { items: cart.items, source: 'mr-finger', itemCount: cart.item_count, didError: false }
                  })
                }));
              } catch (_) {
                document.querySelectorAll('cart-icon').forEach((icon) => {
                  if (typeof icon.renderCartBubble === 'function') icon.renderCartBubble(cart.item_count);
                });
              }
            }
          } catch (_) {}
        } catch (error) {
          feedback.dataset.error = 'true';
          if (!confirmed && !rejected) {
            form.dataset.uncertain = 'true';
            feedback.textContent = messages.uncertain;
            cartLink.hidden = false;
          } else {
            feedback.textContent = error.message || messages.error;
          }
        } finally {
          clearTimeout(deadline);
          form.dataset.busy = 'false';
          form.removeAttribute('aria-busy');
          lockedControls.forEach(([node, disabled]) => { node.disabled = disabled; });
          updateCard(card);
        }
      });
    });
    root.querySelectorAll('[data-mrf-global-size]').forEach((input) => {
      input.addEventListener('change', () => {
        if (!input.checked) return;
        root.querySelectorAll('[data-mrf-card]').forEach((card) => {
          if (card.querySelector('[data-mrf-form]')?.dataset.busy === 'true') return;
          const option = Array.from(card.querySelectorAll('[data-mrf-variant]')).find((node) => node.dataset.size === input.value);
          if (option) {
            option.checked = true;
            updateCard(card);
          }
        });
        toast(messages.size.replace('{{ size }}', input.value));
      });
    });
    root.querySelectorAll('[data-mrf-filter]').forEach((button) => {
      button.addEventListener('click', () => {
        const filter = button.dataset.mrfFilter;
        root.querySelectorAll('[data-mrf-filter]').forEach((node) => node.setAttribute('aria-pressed', String(node === button)));
        root.querySelectorAll('[data-mrf-category]').forEach((node) => { node.hidden = filter !== 'all' && node.dataset.mrfCategory !== filter; });
      });
    });
  }
  function initAll(scope) {
    if (scope.matches && scope.matches('[data-mrf-root]')) init(scope);
    scope.querySelectorAll('[data-mrf-root]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(document));
  else initAll(document);
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();


